//import Libraries
import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Button} from 'reactstrap';

//import Components
import { Modal, CustomInput, Input, Table } from 'reactstrap';
import Language from '../../language/language.json';
import Icons from '../../assets/icons/icons';

//import Style classes
import './Agreements.css'

const logoIcon = Icons.logo

class Agreements extends Component {
    constructor(props){
        super(props);
        this.state = {
            nestedModal : '',
            closeAll : false,
            termOfUseChecked: false,
            privacyChecked: false
        }
    }

    toggleNested() {
        this.props.onResetAuth();
        this.setState(prevState => ({
            nestedModal : !prevState.nestedModal,
            closeAll : false
        }))
    }
    toggleAll() {
          this.setState(prevState => ({
              nestedModal : prevState.nestedModal,
              closeAll : true,
          }))
    }
    render() {
        const {language} = this.props.universal

        return (
            <div>
                <Modal 
                    isOpen={this.props.modal} 
                    toggle={this.props.toggle}
                    onClosed={() => {
                        this.setState({
                            termOfUseChecked : false,
                            privacyChecked : false
                        })
                    }}
                >
                    <div className="SigninContainer">
                        <div className="Logo">{logoIcon}</div>
                        <div className="Title">
                            {Language.agreements.title[language]}
                        </div>
                        <form className="Agreement">
                            <div className="AgreementContent">
                            <h2>이용약관 (필수)</h2>
                                <h6>제1장 총칙</h6>

                                <p>제1조 (목적)<br />
                                ① 이 약관은 대영지에스㈜(이하 "대영지에스"라 합니다)가 제공하는 대영지에스 온라인 서비스(이하 "서비스"라 합니다)를 이용함에 있어 대영지에스와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.<br />
                                ② 이 약관은 대영지에스가 제공하는 서비스(www.dygs.co.kr)의 이용에 적용되는 것입니다.<br />
                                ③ 이 약관에 명시되지 아니한 사항에 대해서는 전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 등에 관한 법률 및 기타 관련 법령 및 대영지에스가 정한 서비스 이용 안내에 따릅니다.</p>

                                <p>제2조 (약관의 효력 및 변경)<br />
                                ① 이 약관은 대영지에스에서 제공하는 서비스에 공지하거나 기타의 방법을 통하여 이를 공지함으로써 효력을 발생합니다.<br />
                                ② 대영지에스는 이 약관의 내용을 변경할 수 있으며, 약관을 변경할 경우에는 적용일자 및 변경사유를 명시하여 제1항과 같은 방법으로 변경된 약관을 공지 또는 통지함으로써 효력을 발생합니다.<br />
                                ③ 회원은 변경된 약관에 동의하지 않을 경우 탈퇴를 요청할 수 있으며, 변경된 약관의 효력 발생일로부터 10일 이후에도 거부의사를 표시하지 아니하고 서비스를 계속 사용할 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.</p>

                                <p>제3조 (용어의 정의)<br />
                                ① 이 약관에서 사용하는 주요한 용어의 정의는 다음과 같습니다.<br />
                                1. 회원 : 사이트와 서비스 이용계약을 체결하거나 이용자 아이디(ID)를 부여 받은 개인 또는 단체를 말합니다.<br />
                                2. 신청자 : 회원가입을 신청하는 개인 또는 단체를 말합니다.<br />
                                3. 아이디(ID) : 회원의 식별과 서비스 이용을 위하여 회원이 정하고 사이트가 승인하는 문자와 숫자의 조합을 말합니다.<br />
                                4. 비밀번호 : 회원이 부여 받은 아이디(ID)와 일치된 회원임을 확인하고, 회원 자신의 비밀을 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 말합니다.<br />
                                5. 해지 : 사이트 또는 회원이 서비스 이용계약을 취소하는 것을 말합니다.<br />
                                ② 이 약관에 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계법령 및 서비스별 안내에서 정하는 바에 의합니다. </p>

                                <h6>제2장 서비스 이용 계약 체결</h6>

                                <p>제4조 (이용계약의 성립)<br />
                                ① 이용약관 하단의 동의 버튼을 누르면 이 약관에 동의하는 것으로 간주됩니다.<br />
                                ② 이용계약은 서비스 이용희망자의 이용약관 동의 후 이용 신청에 대하여 사이트가 승낙함으로써 성립합니다.</p>

                                <p>제5조 (이용 신청)<br />
                                ① 신청자가 본 서비스를 이용하기 위해서는 사이트 소정의 가입신청 양식에서 요구하는 이용자 정보를 기록하여 제출해야 합니다.<br />
                                ② 가입신청 양식에 기재하는 모든 이용자 정보는 모두 실제 데이터인 것으로 간주됩니다. 실명이나 실제 정보를 입력하지 않은 사용자는 법적인 보호를 받을 수 없으며, 서비스의 제한을 받을 수 있습니다.</p>

                                <p>제6조 (이용 신청의 승낙)<br />
                                ① 사이트는 신청자에 대하여 제2항, 제3항의 경우를 예외로 하여 서비스 이용신청을 승낙합니다.<br />
                                ② 사이트는 다음에 해당하는 경우에 그 신청에 대한 승낙 제한사유가 해소될 때까지 승낙을 유보할 수 있습니다.<br />
                                1. 서비스 관련 설비에 여유가 없는 경우<br />
                                2. 기술상 지장이 있는 경우<br />
                                3. 기타 사이트가 필요하다고 인정되는 경우<br />
                                ③ 사이트는 신청자가 다음에 해당하는 경우에는 승낙을 거부할 수 있습니다.<br />
                                1. 다른 개인(사이트)의 명의를 사용하여 신청한 경우<br />
                                2. 이용자 정보를 허위로 기재하여 신청한 경우<br />
                                3. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br />
                                4. 기타 사이트 소정의 이용신청요건을 충족하지 못하는 경우</p>

                                <p>제7조 (개인정보의 보호 및 사용)<br />
                                ① 대영지에스는 이용자의 개인정보를 보호하고 존중합니다. 대영지에스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제를 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br />
                                ▶ 개인정보 보호책임자<br />
                                성명 : 배두직<br />
                                직책 : 대표이사<br />
                                연락처 : 1588-5362<br />
                                ② 대영지에스는 이용자가 서비스를 이용함에 있어서 온라인상에서 대영지에스에게 제공한 개인정보가 보호받을 수 있도록 최선을 다하고 있습니다. 이에 통신비밀보호법, 전기통신사업법, 정보통신망이용촉진 등에 관한 법률, 공공기관의 개인정보보호에 관한 법률 등 정보통신 서비스 제공자가 준수하여야 할 관련법규를 바탕으로 개인정보보호정책을 만들어 이를 준수하고 있습니다. <br />
                                ③ 대영지에스는 이용 신청 시 이용자가 제공하는 정보, 각종 이벤트 참가를 위하여 이용자가 제공하는 정보, 그리고 기타 서비스 이용 과정에서 수집되는 정보 등을 통하여 이용자에 관한 정보를 수집하며, 이용자의 개인정보는 본 이용계약의 이행과 본 이용계약상의 서비스 제공을 위한 목적으로 사용됩니다. <br />
                                ④ 대영지에스는 서비스 제공과 관련하여 취득한 이용자의 신상정보를 본인의 승낙 없이 제3자에게 누설 또는 배포할 수 없으며 상업적 목적으로 사용할 수 없습니다. 다만, 다음의 각 호에 해당하는 경우에는 그러하지 아니합니다.<br />
                                1. 정보통신서비스의 제공에 따른 요금 정산을 위하여 필요한 경우<br />
                                2. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우<br />
                                3. 관계 법령에 의하여 수사상 목적으로 정해진 절차와 방법에 따라 관계기관의 요구가 있는 경우<br />
                                4. 다른 법률에 특별한 규정이 있는 경우<br />
                                5. 정보통신윤리위원회의 요청이 있는 경우 <br />
                                ⑤ 대영지에스는 서비스를 통해 이용자의 컴퓨터에 쿠키를 전송할 수 있습니다. 이용자는 쿠키 수신을 거부하거나 쿠키 수신에 대해 경고하도록 브라우저 설정을 변경할 수 있습니다.</p>

                                <p>제8조 (이용자 정보의 변경)<br />
                                ① 회원은 개인정보관리를 통해 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 회원의 이름, 이메일 등은 수정이 불가능합니다.<br />
                                ② 회원은 이용신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 해야 하며 회원정보를 변경하지 아니하여 발생되는 문제의 책임은 회원에게 있습니다. </p>

                                <h6>제3장 계약 당사자의 의무</h6>

                                <p>제9조 (대영지에스의 의무) <br />
                                ① 대영지에스는 다음 각 호의 사유가 발생한 경우를 제외하고 계속적, 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.<br />
                                1. 서비스용 설비의 보수, 정기점검 또는 대영지에스로 인한 부득이한 경우<br />
                                2. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지한 경우<br />
                                3. 전시, 사변, 천재지변 또는 이에 준 하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우<br />
                                4. 설비 장애 또는 이용 폭주 등으로 인하여 서비스 이용에 지장이 있는 경우 <br />
                                ② 대영지에스는 이용자의 정보를 철저히 보안 유지하며, 서비스를 운영하거나 개선하는 데에만 사용하고, 이외의 다른 목적으로 타 기관 및 개인에게 제공하지 않습니다. 단, 다음 각 호에 해당하는 경우에는 그러하지 아니합니다.<br />
                                1. 관계 법령에 의하여 수사상의 목적으로 관계기관으로부터 요청이 있는 경우<br />
                                2. 정보통신윤리위원회의 요청이 있는 경우<br />
                                3. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우</p>

                                <p>제10조 (이용자의 의무)<br />
                                ① 이용자는 관계 법령, 본 약관의 규정, 이용안내 및 서비스 상에 공지한 주의사항, 대영지에스가 통지하는 사항을 준수하여야 하며, 기타 대영지에스의 업무에 방해되는 행위를 하여서는 안됩니다.<br />
                                ② 이용자는 대영지에스의 사전 동의 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없으며, 법에 저촉되는 자료를 배포 또는 게재할 수 없습니다.<br />
                                ③ 이용자는 자신의 ID와 비밀번호를 유지 관리할 책임이 있으며 자신의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대해 전적인 책임이 있습니다. 또한 자신의 ID와 비밀번호가 자신의 승낙 없이 사용되었을 경우 즉시 대영지에스에 통보하여야 합니다.<br />
                                ④ 이용자는 서비스와 관련하여 다음 사항을 하여서는 안 됩니다.<br />
                                1. 서비스를 이용하여 얻은 정보를 대영지에스의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공하는 행위<br />
                                2. 공공질서 및 미풍양속에 위반되는 저속, 음란물을 게재 또는 음란사이트를 링크하거나 유포하는 등 사회질서를 해치는 행위<br />
                                3. 타인의 명예를 훼손하거나 모욕하는 행위, 타인의 지적재산권 등의 권리를 침해하는 행위<br />
                                4. 해킹 또는 컴퓨터 바이러스를 유포하는 일, 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위<br />
                                5. 다른 이용자 ID를 부정 사용하는 행위<br />
                                6. 다른 사용자의 개인 정보를 수집, 저장하는 행위<br />
                                7. 대영지에스 직원, 운영자 등을 포함한 타인을 사칭하는 행위<br />
                                8. 서비스의 운영에 지장을 주거나 줄 우려가 있는 일체의 행위<br />
                                9. 본 약관을 포함하여 기타 대영지에스가 정한 제반 규정 또는 이용 조건을 위반하는 행위<br />
                                10. 범죄와 결부된다고 객관적으로 판단되는 행위<br />
                                11. 기타 관계 법령에 위배되는 행위</p>

                                <p>제11조 (양도 금지) <br />
                                이용자는 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.</p>

                                <h6>제4장 서비스 이용</h6>

                                <p>제12조 (정보의 제공)<br />
                                대영지에스는 이용자가 서비스 이용 중 필요가 있다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 이용자에게 제공할 수 있습니다.</p>

                                <p>제 13 조 (서비스 제한 및 정지)<br />
                                ① 사이트는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신 사업자가 전기통신서비스를 중지하는 등 기타 불가항력적 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.<br />
                                ② 사이트는 제1항의 규정에 의하여 서비스의 이용을 제한하거나 정지할 때에는 그 사유 및 제한기간 등을 지체없이 회원에게 알려야 합니다.</p>

                                <h6>제5장 계약 해지 및 서비스 이용 제한</h6>

                                <p>제 14 조 (정보의 변경)<br />
                                회원이 주소, 비밀번호 등 고객정보를 변경하고자 하는 경우에는 홈페이지의 회원정보 변경 서비스를 이용하여 변경할 수 있습니다. </p>

                                <p>제 15 조 (계약사항의 해지)<br />
                                ①회원은 서비스 이용계약을 해지할 수 있으며, 회원이 이용 계약을 해지하고자 하는 때에는 회원 본인이 직접 서비스 내 회원탈퇴 메뉴를 이용하여 가입해지를 해야 합니다. 사이트는 해지신청이 접수된 당일부터 해당 회원의 서비스 이용을 제한합니다. 사이트는 회원이 다음 각 항에 해당하여 이용계약을 해지하고자 할 경우에는 해지조치 7일전까지 그 뜻을 이용고객에게 통지하여 소명할 기회를 주어야 합니다.<br />
                                1. 이용고객이 이용제한 규정을 위반하거나 그 이용제한 기간 내에 제한 사유를 해소하지 않는 경우<br />
                                2. 정보통신윤리위원회가 이용해지를 요구한 경우<br />
                                3. 이용고객이 정당한 사유 없이 의견진술에 응하지 아니한 경우<br />
                                4. 타인 명의로 신청을 하였거나 신청서 내용의 허위 기재 또는 허위서류를 첨부하여 이용계약을 체결한 경우<br />
                                대영지에스는 상기 규정에 의하여 해지된 이용고객에 대해서는 별도로 정한 기간 동안 가입을 제한할 수 있습니다.<br />
                                ② 대영지에스는 회원이 서비스 이용내용에 있어서 본 약관 제10조 내용을 위반하거나, 다음 각 호에 해당하는 경우 사전 통지 없이 이용 계약을 해지하거나 또는 기간을 정하여 서비스 이용을 중지할 수 있습니다.<br />
                                1. 공공질서 및 미풍양속에 반하는 경우<br />
                                2. 범죄적 행위에 관련되는 경우<br />
                                3. 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행할 경우<br />
                                4. 타인의 ID 및 비밀번호를 도용한 경우<br />
                                5. 가입한 이름이 실명이 아닌 경우<br />
                                6. 타인의 명예를 손상시키거나 불이익을 주는 경우<br />
                                7. 같은 사용자가 다른 ID로 이중 등록을 한 경우<br />
                                8. 대영지에스 직원 및 운영자 등을 포함한 타인을 사칭하기 위해 ID 및 별명을 사용할 경우<br />
                                9. 서비스에 위해를 가하는 등 건전한 이용을 저해하는 경우<br />
                                10. 구입한 상품 등에 특별한 하자가 없는데도 불구하고 상습적인 환불 요청 또는 계약취소 등으로 대영지에스의 업무를 방해하는 경우<br />
                                11. 기타 관련 법령이나 대영지에스가 정한 이용 조건에 위배되는 경우<br />
                                ③ 대영지에스의 해제, 해지 및 이용제한에 대하여 이용자는 이의신청을 할 수 있습니다.</p>

                                <h6>제 6장 손해배상</h6>
                                <p>제17조 (손해배상) <br/>
                                대영지에스가 제공하는 서비스 중에서 개인정보보호정책에서 정하는 내용에 해당하지 않는 사항에 대하여는 어떠한 손해도 책임을 지지 않습니다.</p>

                                <p>제18조 (면책 조항)<br />
                                ① 대영지에스는 이용자가 서비스를 통해 게재 또는 전송한 정보, 자료, 사실의 정확성, 신뢰성 등 내용에 관하여 어떠한 보증도 하지 아니하며 이용자의 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해 책임을 지지 아니합니다.<br />
                                ② 대영지에스는 이용자가 서비스를 이용하며 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 아니합니다.<br />
                                ③ 대영지에스는 이용자의 귀책사유로 인하여 서비스 이용의 장애가 발생한 경우에는 책임이 면제 됩니다.<br />
                                ④ 본 약관의 규정을 위반함으로 인하여 대영지에스에 손해가 발생하게 되는 경우, 이 약관을 위반한 이용자는 대영지에스에 발생되는 모든 손해를 배상하여야 하며, 동 손해로부터 대영지에스를 면책 시켜야 합니다.</p>

                                <p>제19조 (분쟁의 해결)<br />
                                대영지에스와 이용자 사이의 분쟁이 발생할 경우 관할은 대영지에스의 본사 소재지를 관할하는 지방법원을 전속관할로 합니다.</p>

                                <p>{"<부칙>"}<br />
                                1. 본 약관은 2019년 05월 01일부터 적용됩니다.<br />
                                </p>
                            </div>
                            <CustomInput 
                                className="AgreementCheck" type="checkbox" name="customSwitch" 
                                id="TermOfUseCheckBox"
                                label="약관을 충분히 이해하였으며 동의합니다(필수)" 
                                inline checked={this.state.termOfUseChecked} onClick={e => this.setState({ termOfUseChecked: e.target.checked })}/>
                            <div className="AgreementContent">
                                <h2>{"개인정보 수집 및 이용에 대한 안내 (필수)"}</h2>
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            {/* <th>#</th> */}
                                            <th>수집목적</th>
                                            <th>수집항목</th>
                                            <th>보유기간</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {/* <th scope="row">1</th> */}
                                            <td>이용자 식별 및 본인 여부 확인</td>
                                            <td>이메일, 이름, 패스워드</td>
                                            <td rowSpan="3">회원탈퇴 시까지</td>
                                        </tr>
                                        <tr>
                                            {/* <th scope="row">2</th> */}
                                            <td>계약 이행을 위한 연락 및 물품구매계약 이행</td>
                                            <td>회사명, 휴대전화번호, 주소, 온실형태, 재배 작물, 재배 면적</td>
                                        </tr>
                                        <tr>
                                            {/* <th scope="row">3</th> */}
                                            <td>만14세 미만 가입 시 법정대리인 동의</td>
                                            <td>법정대리인 이름, 법정대리인 휴대전화번호</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <p>{"* 서비스 제공을 위하여 필요한 최소한의 개인정보이므로 동의를 해주셔야 서비스를 이용하실 수 있습니다.\n* 이외 서비스 이용과정에서 별도 동의를 통해 추가정보 수집이 있을 수 있습니다."}</p>
                            </div>
                            <CustomInput 
                                className="AgreementCheck" type="checkbox" name="customSwitch" 
                                id="PrivacyCheckBox"
                                label="개인정보 수집 및 이용에 대한 안내를 이해하였으며 동의합니다(필수)" 
                                inline checked={this.state.privacyChecked} onClick={e => this.setState({ privacyChecked: e.target.checked })}/>
                            <div className="element">
                                <Button 
                                    size="lg"
                                    color="info"
                                    className="btn"
                                    disabled={!this.state.termOfUseChecked || !this.state.privacyChecked}
                                    onClick={this.props.onAgreeClick}
                                >
                                    {Language.agreements.agree[language]}
                                </Button>
                                <h4>
                                </h4>
                                <h4>
                                {
                                    (!this.state.privacyChecked || !this.state.termOfUseChecked) && <p className="red">{"필수 약관 동의를 하셔야 회원가입할 수 있습니다"}</p>
                                }
                                </h4>
                            </div>

                        </form>
                        <hr/>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
        universal : state.universal,
        signIn : state.sign.signIn
    }
}

export default connect(mapStateToProps, null)(Agreements);



// WEBPACK FOOTER //
// ./src/components/Agreements/Agreements.js